// extracted by mini-css-extract-plugin
export default {"divHeader":"Message_divHeader__T7-ft","divBody":"Message_divBody__XQ-Be"};